export const filelist = [
    {
        value: "Informationsschreiben",
        link: "/protocols/20251024_2/1_Informationsschreiben.pdf"
    },
    {
        value: "Session 2025-10-24",
        link: "/protocols/20251024_2/2_Session_2025-10-24.pdf"
    },
]